var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/mint_logo.png")}}),_c('div',{staticClass:"inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }